export const ACTION_PREFIX_CONDITION = 'condition'